export const favoriteLyrics = [
  { text: "Hoo", start: 8, end: 8.8 },
  { text: "Hoo", start: 9, end: 10.5  },
  { text: "Hoo, Hoo, Hoo", start: 10.5, end: 12  },
  { text: "Here I come round the corner with a glock on my hip", start: 12, end: 15.3  },
  { text: "Prayin I do and prayin I don't miss", start: 15.4, end: 17.6  },
  { text: "I'm gunna start an uproar", start: 18.5, end: 21.3  },
  { text: "Uproar", start: 21.3, end: 21.7  },
  { text: "What does she have that I didn't before", start: 21.8, end: 24.4  },
  { text: "Before", start: 24.4, end: 24.8  },
  { text: "Lawd you got a twinkle in your eye now", start: 24.8, end: 28.3  },
  { text: "Shol would be tragic if yo shine ran out", start: 28.3, end: 31.6  },
  { text: "The possibilities are endless", start: 31.6, end: 34  },
  { text: "I look careless you look like a victim", start: 34, end: 36.2  },
  { text: "Till an innocent bystander whispers", start: 36.2, end: 38.7  },
  { text: "Sim simma", start: 38.7, end: 39.6  },
  { text: "Simma down", start: 39.6, end: 41  },
  { text: "Why you wanna throw it all away now", start: 41, end: 44.5  },
  { text: "I want him down on his knees", start: 44.49, end: 46.5  },
  { text: "Why's he cryin for her and not cryin for me", start: 46.49, end: 50.5  },
  { text: "Oh lawd forgive em for they do not know", start: 50.5, end: 53.5  },
  { text: "The damage that they've caused and the heartache", start: 53.5, end: 56.7  },
  { text: "It impedes", start: 56.7, end: 58.1  },
  { text: "On my soul", start: 58.13, end: 59.7  },
  { text: "I thought I was your", start: 60, end: 64.5  },
  { text: "Favorite favorite favorite", start: 64.5, end: 65.7  },
  { text: "You were my baby", start: 65.7, end: 68.4  },
  { text: "Favorite favorite favorite", start: 68.4, end: 70  },
  { text: "I was your favorite", start: 70, end: 73  },
  { text: "Favorite favorite favorite", start: 73, end: 75  },
  { text: "Oooh", start: 75, end: 76.2  },
  { text: "Favorite favorite favorite", start: 76.2, end: 77.4  },
  { text: "You were my favorite", start: 78, end: 79.3  },
  { text: "Favorite favorite favorite", start: 79.3, end: 79.9  },
  { text: "I was your baby", start: 80, end: 83  },
  { text: "Favorite favorite favorite", },
  { text: "Oooh", start: 83, end: 88  },
  { text: "If it's love that you need", start: 88, end: 91  },
  { text: "Baby I can set you free", start: 91, end: 94.5  },
  { text: "Help you see, what I know", start: 94.5, end: 97.7  },
  { text: "That this hearts worth more than gold", start: 97.7, end: 101  },
  { text: "If it's love that you need", start: 101, end: 104.2  },
  { text: "Baby I can set you free", start: 104.2, end: 107.3  },
  { text: "Help you see", start: 107.3, end: 108.9  },
  { text: "What I know", start: 108.9, end: 110.1  },
  { text: "That this hearts worth more than gold", start: 110.1, end: 113  },
  { text: "So silly of me to think", start: 113, end: 116.3  },
  { text: "The more that you weep she clings", start: 116.3, end: 119.6  },
  { text: "I've got an axe to grind", start: 119.6, end: 122.8  },
  { text: "Your fingers intertwined", start: 122.8, end: 125.3  },
  { text: "But in the back of my mind", start: 125.3, end: 128  },
  { text: "How'd I get to be so cold", start: 128, end: 129.6  },
  { text: "Cold cold", start: 129.6, end: 130  },
  { text: "Tryna be your centerfold", start: 130, end: 132  },
  { text: "Fold fold", start: 132, end: 132.7  },
  { text: "Why is it never me you want", start: 132.7, end: 134  },
  { text: "Too expensive to wear your heart on your sleeve", start: 134, end: 137  },
  { text: "Than to acknowledge who you are is who you'll always be", start: 137, end: 141  },
  { text: "Now I see you walkin round with my opposite", start: 141, end: 144  },
  { text: "When she gets the best of you I lose all common sense", start: 144, end: 147.5  },
  { text: "To say I won't hurt you now, I can't make no promises", start: 147.5, end: 150.5  },
  { text: "I just need to hear you say that I was your", start: 150.5, end: 154  },
  { text: "Favorite favorite favorite", start: 154, end: 156  },
  { text: "You were my baby", start: 156, end: 158.3  },
  { text: "Favorite favorite favorite", start: 158.3, end: 159  },
  { text: "I was your favorite", start: 159, end: 161.5  },
  { text: "Favorite favorite favorite", start:161.5 , end: 163.4  },
  { text: "Oooh", start: 164, end: 166  },
  { text: "Favorite favorite favorite", start: 166, end: 168.5  },
  { text: "You were my favorite", start: 168.5, end:  171.2 },
  { text: "Favorite favorite favorite", start: 171.2, end: 172  },
  { text: "I was your baby", start: 172, end: 174.3  },
  { text: "Favorite favorite favorite", start: 174.3, end: 175  },
  { text: "Oooh", start: 175.5, end: 177  },
  { text: "Ca, ca, come-on", start: 177, end: 178   },
  { text: "Ca, ca, come-on", start: 178, end: 179 },
  { text: "Ca, ca, Ca, ca, Ca, ca, Ca, ca", start: 181, end: 184  },
  { text: "Come-on", start: 184, end: 186  },
  { text: "Ca, ca, come-on", start: 186, end: 187.5  },
  { text: "Ca, ca, come-on", start: 187.5, end: 189  },
  { text: "Ca, ca, Ca, ca, Ca, ca, Ca, ca", start: 189, end: 191  },
  { text: "Come-on", start: 191, end: 192  },
  { text: "Come-on", start: 192, end: 193  },
  { text: "Come-on", start: 193, end: 195  },
  { text: "Come-on", start: 195, end: 197.5 },
  { text: "Ca, ca, come-on", start: 197.5, end: 199  },
  { text: "Ca, ca, Ca, ca, Ca, ca, Ca, ca", start: 200, end: 204.5  },
  { text: "Come-on", start: 205, end: 206 },
] as const satisfies ReadonlyArray<{ readonly text: string, readonly start?: number, readonly end?: number }>;
